import { AMOUNT_MASK, isAmountsHidden } from './privacy'

const eur = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})

const eur2 = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
})

const pct = new Intl.NumberFormat('fr-FR', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 2,
})

export const formatEUR = (n: number) => (isAmountsHidden() ? AMOUNT_MASK : eur.format(n || 0))
export const formatEUR2 = (n: number) => (isAmountsHidden() ? AMOUNT_MASK : eur2.format(n || 0))
export const formatPct = (n: number) => pct.format((n || 0) / 100)

export const formatDate = (iso: string) =>
  new Date(iso).toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
